/** The writes of this session that a list does not show yet, and the atoms that hold them. */
import type { Getter, PrimitiveAtom, Setter, WritableAtom } from 'jotai';

export enum WriteState {
    Saving = 'saving',
    /** The server took it; the row holds it until a load that started after the answer. */
    Saved = 'saved',
    /** The row keeps it until the operator sends it again or drops it. */
    Failed = 'failed',
}

/** A write of this session that the list does not show yet. */
export type Write<R> = R & {
    state: WriteState;
    answeredAtMs?: number;
    error?: Error;
};

export type Writes<R> = ReadonlyMap<string, Write<R>>;

export interface WritesAtoms<R> {
    writes: PrimitiveAtom<Writes<R>>;
    /** Shows the request as saving. A write with the same id is replaced. */
    start: WritableAtom<null, [string, R], void>;
    /** The server took the write: the list loads again, and that load ends the write. */
    answer: WritableAtom<null, [string], void>;
    /** The server refused the write or did not answer: the row keeps it as failed. */
    fail: WritableAtom<null, [string, Error], void>;
    /** Ends the write at once, for example when the operator discards it. */
    drop: WritableAtom<null, [string], void>;
    /** Ends the answered writes that a load which started at `startedAtMs` shows. */
    endAnswered: (get: Getter, set: Setter, startedAtMs: number) => void;
}
